import { BLOG_CTAS } from "@/blog/routes";
import type { BlogCtaId } from "@/blog/types";
import { ButtonLink } from "@/components/ui/Button";
import { FreeAuditButton } from "@/components/ui/Cta";

/** Closing call to action: the one Jenifer picked for the article. */
export function BlogCtaBand({ cta, location }: { cta: BlogCtaId; location: string }) {
  const copy = BLOG_CTAS[cta];
  return (
    <section aria-labelledby={`cta-${location}`} className="mx-auto max-w-7xl px-4 pb-24 sm:px-6 md:pb-32 lg:px-8">
      <div
        data-reveal=""
        data-track-location={location}
        className="light-pool relative flex flex-col gap-8 overflow-hidden rounded-[2.25rem] bg-teal-soft px-7 py-10 [--pool-x:90%] [--pool-y:0%] sm:px-10 md:flex-row md:items-center md:justify-between md:gap-12 lg:px-14 lg:py-12"
      >
        <div className="max-w-2xl">
          <h2
            id={`cta-${location}`}
            className="font-display text-2xl sm:text-3xl font-semibold leading-[1.12] tracking-[-0.02em] text-brand-primary"
          >
            {copy.title}
          </h2>
          <p className="mt-3 text-lg leading-relaxed text-ink-soft">{copy.text}</p>
        </div>
        {copy.to ? (
          <ButtonLink to={copy.to} variant="primary" size="lg" arrow className="shrink-0">
            {copy.button}
          </ButtonLink>
        ) : (
          <FreeAuditButton location={location} variant="primary" label={copy.button} className="shrink-0" />
        )}
      </div>
    </section>
  );
}
